module.exports = __webpack_public_path__ + "static/media/home2.c1a569cb.webp";